<template>
    <v-container fluid>
        <h2 class="text-h5">{{ $t("risk-aversion.cip-cgu.title") }}</h2>
        <v-row>
            <v-col>
                {{ $t("risk-aversion.cip-cgu.description") }}
                <br /><br />
                {{ $t("risk-aversion.cip-cgu.description-auto") }}
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <EqsBtn
                    class="ma-2"
                    outlined
                    color="success"
                    v-bind="{
                        action: () =>
                            window.open(
                                'https://www.equisafe-invest.io/cgu-equisafe-invest',
                                '_blank'
                            )
                    }"
                >
                    <span class="no-text-transform">
                        {{ $t("risk-aversion.dialog.cgu") }}
                    </span>
                </EqsBtn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <EqsCheckbox
                    :value.sync="formData.accept_cgu"
                    class="font-weight-bold mt-4 mb-4"
                    v-bind="{
                        ...schemaDouble.accept_cgu
                    }"
                >
                    <template #label>
                        <div class="ml-4 font-weight-bold">
                            <p class="pt-8">
                                {{ $t("risk-aversion.cip-cgu.accept-cgu") }}
                            </p>
                            <p>
                                {{ $t("risk-aversion.cip-cgu.us-canada-declaration") }}
                            </p>
                        </div>
                    </template>
                </EqsCheckbox>
            </v-col>
        </v-row>
        <v-dialog
            v-model="dialogProxy"
            closable
            transition="dialog-bottom-transition"
            max-width="600"
        >
            <v-card class="pa-4">
                <v-card-title class="text-h5" style="word-break: break-word">
                    {{ $t("risk-aversion.cip-cgu.dialog-title") }}
                </v-card-title>
                <v-card-text>
                    <div v-html="$t('risk-aversion.cip-cgu.dialog-body')"></div>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" text @click="dialogProxy = false">
                        {{ $t("risk-aversion.cip-cgu.dialog-understood") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { formMixin } from "@equisafe-ui-vue/src/mixins/formMixin";
export default {
    name: "IntroPage",
    mixins: [formMixin],
    data() {
        return {
            window,
            dialogProxy: true
        };
    },
    methods: {
        openCguUniverse() {
            window.open(this.$store.getters.universe.cgu_url, "_blank");
        }
    }
};
</script>

<style lang="scss" scoped></style>
